import React, { useEffect, useState } from 'react'
import { Footer } from '../Home/Footer'
import { Header } from '../wallet/header/header'
import { Link } from 'react-router-dom'
import { MiniHeader } from '../Home/MiniHeader'

//api
import axios from "../utils/axios"

import { updatePassword,EmailAuthProvider,reauthenticateWithCredential } from 'firebase/auth'
import { dataBase } from "../utils/FirebaseConfig"


//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'

//form
import {useForm} from "react-hook-form"
import * as yup from "yup"
import {yupResolver} from "@hookform/resolvers/yup"
import useAuth from '../context/hook/useAuth'

//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye,faEyeSlash,faXmark } from '@fortawesome/free-solid-svg-icons';

import site from "../utils/SiteSettings"

export const Setting = () => {


    const {user,dispatch} = useAuth()

    const [profile, setProfile] = useState([])

    const [showIcon, setShowIcon] = useState(false)

    const [showIconNew, setShowIconNew] = useState(false)

    const schema = yup.object().shape({
        old:yup.string().required(),
        new:yup.string().min(7).max(20).required(),
        confirm_password: yup.string().label('confirm password').required().oneOf([yup.ref('new'), null], 'Passwords must match'),
    })

    const {register, handleSubmit, reset, formState: { errors }} = useForm({
        resolver: yupResolver(schema)
    });

    const getProfile = async () => {
        
        try {
            await axios.get(`/profile/detail`,
                {
                    headers:{
                        "Content-Type": "application/json",
                        "Authorization":user
                    },
                    withCredentials:true,
                }
            ).then((res)=>{
                let data = JSON.parse(res.data)
                // console.log(data)
                setProfile(data)
            }).catch(err=>{
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        getProfile()
        // eslint-disable-next-line
    },[])

    const onSubmit = async (data,e) => {
        
        e.preventDefault();
        let password = data.new;
        // let token = user
        try {
            
        // const user = auth.currentUser;
            if( password.match(/[!@#$%^&*]/) != null && password.match(/.{8,}/) != null &&  password.match(/[0-9]/) != null && password.match(/[A-Z]/) != null ){
                if(data.old !== data.new){
                    var userFbDetail = dataBase.currentUser;
                    var credentials = EmailAuthProvider.credential(profile.email,data.old)
                    await reauthenticateWithCredential(userFbDetail,credentials)
                    .then((res)=>{
                        updatePassword(userFbDetail,data.new) 
                        .then(async()=> {
                            await axios.put("/profile/password/update",
                                {
                                    password:password
                                },{
                                    headers:{
                                        "Content-Type": "application/json",
                                        "Authorization":user
                                    },
                                    withCredentials:true,
                                }
                            ).then(()=>{
                                setTimeout(()=>{
                                    localStorage.removeItem("cthash")
                                    dispatch({
                                        type: "LOGOUT",
                                    })
                                },2000)
                                setTimeout(()=>{
                                    //this is used to redirect to login after the registered in successfully
                                    // window.location.href="/login"
                                    window.location.href="/login"
                                },4000)
                                toast.success("Password changed successful",{position:'top-right'})
                            })
                            console.log("Password update successful!");
                        })
                        .catch((error)=> {
                            console.log(error)
                        });                        
                    })
                    .catch(err=>{
                        // console.log(err)
                        toast.error("Please enter a valid email and password",{position:"top-right"})
                    })
                }else{
                    console.log("Old password and new password are same. Please use different password")
                    toast.error(<div>Old password and new password are same.<br/> Please use different password.</div>,{position:"top-right"})            
                }
            }else{
                console.log("invalid password")
                toast.error(<div>Password must be:<br/> 1) Between 8-30 characters,<br/> 2) At least one upper and lower case letter,<br/> 3) At least one number,<br/> 4) At least one special character</div>,{position:"top-right"})
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handlSshowHide =()=>{
        setShowIcon(!showIcon)
    }

    const handlSshowHideNew =()=>{
        setShowIconNew(!showIconNew)
    }

  return (
    <div>
        <div>
        <Header/>
        {/* <!-- service section start --> */}
        <section className="feature-section pb-0">
            <div className="container pb-md-5 pb-0">
                <div className="title-basic fs-sm">
                    {/* <!-- <h2 class="text-white">A Wide Range of
                        Functionality to Support Any Use Case</h2> --> */}
                </div>
                <ul className="tab-section mt-80">
                    <li><Link to={"/wallet"}>Wallet</Link></li>
                    <li><Link to={"/buy/token"}>Buy {site?.site?.siteName}</Link></li>
                    <li><Link to={"/deposit"}>Deposit</Link></li>
                    <li ><Link to={"/withdrawal"}>Withdraw</Link></li>
                    <li className="active"><Link to={""}>Settings</Link></li>
                    <li><MiniHeader /></li>
                </ul>
                <div className="row g-xxl-5 g-4 justify-content-center">
                <div className="col-lg-5">
                    <div className="buy-box">
                        <div className="buy-head">
                            <h3>Reset Password</h3>
                        </div>
                        <div className="deposit-area">
                            <form action="" onSubmit={handleSubmit(onSubmit)}>
                                <div className="">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Name: {profile.name}</label>
                                </div>
                                <div className="">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Email: {profile.email}</label>
                                </div>
                                <div className="pos-rel">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Old password</label>
                                    <input {...register("old")} type={showIcon ? "text" : "password"}  className="form-control" id="exampleFormControlInput1" placeholder="Old password"/>
                                    <div className='log-icon' style={{marginTop:"12px"}}>
                                        <FontAwesomeIcon icon={faXmark} onClick={()=>{reset({old:""})}} />
                                        {
                                            showIcon ? (
                                                <FontAwesomeIcon icon={faEye}  id='show_hide' onClick={handlSshowHide}  />
                                            ) : (
                                                <FontAwesomeIcon icon={faEyeSlash}  id='show_hide' onClick={handlSshowHide}  />
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="pos-rel">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">New password</label>
                                    <input {...register("new")} type={showIconNew ? "text" : "password"}  className="form-control" id="exampleFormControlInput1" placeholder="New password"/>
                                    {errors.password && <p style={{fontSize:'12px',color:'red'}}>Password has to be between 8-30 characters, and contains at least one uppercase letter, one lowercase letter and a number</p>}
                                    <div className='log-icon' style={{marginTop:"12px"}}>
                                        <FontAwesomeIcon icon={faXmark} onClick={()=>{reset({new:""})}} />
                                        {
                                            showIconNew ? (
                                                <FontAwesomeIcon icon={faEye}  id='show_hide' onClick={handlSshowHideNew}  />
                                            ) : (
                                                <FontAwesomeIcon icon={faEyeSlash}  id='show_hide' onClick={handlSshowHideNew}  />
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="pos-rel">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Confirm password</label>
                                    <input {...register("confirm_password")} type="password" className="form-control" id="exampleFormControlInput1" placeholder="Confirm password"/>
                                    {errors.confirm_password && <p style={{fontSize:'12px',color:'red'}}>Confirm Password must match with Password</p>}
                                    <div className='log-icon' style={{marginTop:"12px"}}>
                                        <FontAwesomeIcon icon={faXmark} onClick={()=>{reset({confirm_password:""})}} />
                                    </div>
                                </div>
                                <div className="qtsYk">
                                    <button data-size="large" type='submit' className="jRLsY SOUdU" style={{"width": "100%", marginTop: "24px"}}>
                                        <span>
                                            Submit
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        {/* <!-- service section end --> */}

        <Footer />

    </div>
    </div>
  )
}
